var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBotImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 37,
    viewBox: "0 0 21 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.40326 20.933C5.3384 21.1998 5.96105 20.867 6.59374 21.5282C6.66637 21.604 7.03733 21.9918 7.07976 22.5672C7.11333 23.0256 6.92478 23.4176 6.79428 23.5986C6.00141 24.6977 3.16088 24.0336 1.42846 23.0618C1.05076 22.8499 0.0373522 22.2815 0.123206 21.7339C0.158391 21.5095 0.366143 21.3641 0.515702 21.2624C1.17701 20.8124 1.96065 20.8929 2.40326 20.933Z",
    fill: "url(#paint0_linear_87_1131)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.601 5.00988H10.9961V1.0397H11.601V5.00988Z",
    fill: "url(#paint1_linear_87_1131)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0736 0.775066C12.0736 1.20311 11.7264 1.55013 11.2985 1.55013C10.8703 1.55013 10.5232 1.20311 10.5232 0.775066C10.5232 0.347026 10.8703 0 11.2985 0C11.7264 0 12.0736 0.347026 12.0736 0.775066Z",
    fill: "url(#paint2_linear_87_1131)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.837 0.472671C11.837 0.603207 11.7312 0.709044 11.6006 0.709044C11.4701 0.709044 11.3643 0.603207 11.3643 0.472671C11.3643 0.342134 11.4701 0.236298 11.6006 0.236298C11.7312 0.236298 11.837 0.342134 11.837 0.472671Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3874 7.20299H9.20896C8.90083 7.20299 8.65112 6.95328 8.65112 6.64515V5.15183C8.65112 4.8437 8.90083 4.59399 9.20896 4.59399H13.3874C13.6954 4.59399 13.9452 4.8437 13.9452 5.15183V6.64515C13.9452 6.95328 13.6954 7.20299 13.3874 7.20299Z",
    fill: "url(#paint3_linear_87_1131)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7699 15.8807C20.7699 18.2926 18.8144 20.2479 16.4025 20.2479H6.19352C3.7915 20.2479 1.82617 18.2826 1.82617 15.8807V13.6119C1.82617 9.33833 5.32274 5.84177 9.59635 5.84177H12.9994C17.2732 5.84177 20.7699 9.33833 20.7699 13.6119V15.8807Z",
    fill: "url(#paint4_linear_87_1131)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9726 8.3271C17.9828 8.68907 17.6873 9.12181 17.3488 9.15873C17.0317 9.19343 16.7784 8.8695 16.5173 8.53532C16.2598 8.20595 15.6968 7.35975 15.921 7.12041C16.2167 6.80463 17.9484 7.47325 17.9726 8.3271Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3446 6.67838C15.3446 6.82719 15.2238 6.94785 15.075 6.94785C14.9262 6.94785 14.8057 6.82719 14.8057 6.67838C14.8057 6.52956 14.9262 6.40891 15.075 6.40891C15.2238 6.40891 15.3446 6.52956 15.3446 6.67838Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7921 5.36632C13.7728 5.36904 13.7605 5.25579 13.6661 5.08067C13.6661 5.08067 13.622 4.99891 13.5716 4.92951C13.4091 4.70598 12.8587 4.71092 12.8155 4.71129C11.9579 4.71882 11.4069 4.66449 11.407 4.66955C11.4071 4.67399 11.8091 4.66572 12.1038 4.65979C12.9351 4.64287 13.4302 4.59817 13.6425 4.82083C13.7306 4.91321 13.7748 5.03349 13.7748 5.03349C13.8351 5.19676 13.815 5.36298 13.7921 5.36632Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8024 15.4671C16.5544 15.5896 16.2766 15.6539 15.9942 15.6539H4.62607C4.34376 15.6539 4.06589 15.5896 3.81803 15.4671C3.20919 15.1662 2.8655 14.5586 2.95158 13.935L2.95788 13.8896C3.24908 11.7779 5.16168 10.1544 7.50627 10.0325C8.49832 9.98091 9.53939 9.95424 10.6253 9.96053C11.4761 9.96547 12.2983 9.99042 13.0899 10.0312C15.4435 10.1526 17.3702 11.7696 17.6625 13.8893C17.6645 13.9045 17.6667 13.9197 17.6688 13.935C17.7548 14.5586 17.4112 15.1662 16.8024 15.4671Z",
    fill: "url(#paint5_linear_87_1131)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9826 13.38C16.8962 13.441 16.2935 12.2134 14.6761 11.1491C14.1076 10.7749 13.5462 10.5084 13.5795 10.4309C13.6134 10.3521 14.2456 10.4985 14.7518 10.7333C16.3643 11.4814 17.0854 13.3075 16.9826 13.38Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2755 13.035C15.2755 14.2278 14.3071 15.1962 13.1143 15.1962C11.9216 15.1962 10.9531 14.2278 10.9531 13.035C10.9531 11.8423 11.9216 10.8738 13.1143 10.8738C14.3071 10.8738 15.2755 11.8423 15.2755 13.035Z",
    fill: "url(#paint6_radial_87_1131)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.658 13.0351C14.658 13.8871 13.9662 14.5788 13.1143 14.5788C12.2623 14.5788 11.5706 13.8871 11.5706 13.0351C11.5706 12.1831 12.2623 11.4914 13.1143 11.4914C13.9662 11.4914 14.658 12.1831 14.658 13.0351Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3491 13.0351C14.3491 13.7167 13.7957 14.27 13.1141 14.27C12.4325 14.27 11.8792 13.7167 11.8792 13.0351C11.8792 12.3535 12.4325 11.8001 13.1141 11.8001C13.7957 11.8001 14.3491 12.3535 14.3491 13.0351Z",
    fill: "#04121C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47107 13.035C9.47107 14.2278 8.50264 15.1962 7.30988 15.1962C6.11711 15.1962 5.14868 14.2278 5.14868 13.035C5.14868 11.8423 6.11711 10.8738 7.30988 10.8738C8.50264 10.8738 9.47107 11.8423 9.47107 13.035Z",
    fill: "url(#paint7_radial_87_1131)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85354 13.0351C8.85354 13.8871 8.1618 14.5788 7.30982 14.5788C6.45785 14.5788 5.76611 13.8871 5.76611 13.0351C5.76611 12.1831 6.45785 11.4914 7.30982 11.4914C8.1618 11.4914 8.85354 12.1831 8.85354 13.0351Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54489 13.0351C8.54489 13.7167 7.9915 14.27 7.30992 14.27C6.62834 14.27 6.07495 13.7167 6.07495 13.0351C6.07495 12.3535 6.62834 11.8001 7.30992 11.8001C7.9915 11.8001 8.54489 12.3535 8.54489 13.0351Z",
    fill: "#04121C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54489 13.0351C8.54489 13.7172 7.99199 14.27 7.30992 14.27C6.62785 14.27 6.07495 13.7172 6.07495 13.0351C6.07495 12.353 6.62785 11.8001 7.30992 11.8001C7.99199 11.8001 8.54489 12.353 8.54489 13.0351Z",
    fill: "#04121C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_87_1131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 11,
    width: 9,
    height: 4
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56637 13.0361C8.56637 13.7182 8.01348 14.2711 7.3314 14.2711C6.64933 14.2711 6.09644 13.7182 6.09644 13.0361C6.09644 12.354 6.64933 11.8011 7.3314 11.8011C8.01348 11.8011 8.56637 12.354 8.56637 13.0361Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3706 13.0369C14.3706 13.719 13.8177 14.2718 13.1356 14.2718C12.4535 14.2718 11.9006 13.719 11.9006 13.0369C11.9006 12.3548 12.4535 11.8019 13.1356 11.8019C13.8177 11.8019 14.3706 12.3548 14.3706 13.0369Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_87_1131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.14168 12.71C8.14168 12.9744 7.92741 13.1888 7.663 13.1888C7.39847 13.1888 7.18408 12.9744 7.18408 12.71C7.18408 12.4456 7.39847 12.2314 7.663 12.2314C7.92741 12.2314 8.14168 12.4456 8.14168 12.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31374 14.0359C7.31374 14.1413 7.22816 14.2268 7.12257 14.2268C7.0171 14.2268 6.93164 14.1413 6.93164 14.0359C6.93164 13.9304 7.0171 13.8449 7.12257 13.8449C7.22816 13.8449 7.31374 13.9304 7.31374 14.0359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.64918 13.7494C6.64918 13.8022 6.60645 13.8449 6.55372 13.8449C6.50098 13.8449 6.45825 13.8022 6.45825 13.7494C6.45825 13.6967 6.50098 13.654 6.55372 13.654C6.60645 13.654 6.64918 13.6967 6.64918 13.7494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9329 12.71C13.9329 12.9744 13.7184 13.1888 13.454 13.1888C13.1896 13.1888 12.9753 12.9744 12.9753 12.71C12.9753 12.4456 13.1896 12.2314 13.454 12.2314C13.7184 12.2314 13.9329 12.4456 13.9329 12.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1048 14.0359C13.1048 14.1413 13.0192 14.2268 12.9136 14.2268C12.8082 14.2268 12.7227 14.1413 12.7227 14.0359C12.7227 13.9304 12.8082 13.8449 12.9136 13.8449C13.0192 13.8449 13.1048 13.9304 13.1048 14.0359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4402 13.7494C12.4402 13.8022 12.3975 13.8449 12.3447 13.8449C12.292 13.8449 12.249 13.8022 12.249 13.7494C12.249 13.6967 12.292 13.654 12.3447 13.654C12.3975 13.654 12.4402 13.6967 12.4402 13.7494Z",
    fill: "white"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5864 16.736C12.5477 16.9388 12.3635 17.0815 12.1571 17.0834L9.30434 17.1086C9.09802 17.1106 8.91136 16.9712 8.8689 16.7693C8.85009 16.6796 8.83759 16.5873 8.8318 16.4934C8.83023 16.4674 8.83928 16.4419 8.85706 16.4229C8.87484 16.4039 8.89958 16.3931 8.92564 16.3928L12.5246 16.3608C12.5502 16.3606 12.5748 16.3709 12.5927 16.3895C12.6105 16.4079 12.62 16.4328 12.6188 16.4584C12.6147 16.5528 12.6037 16.6456 12.5864 16.736Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5864 16.7361C12.4194 17.6052 11.6591 18.2651 10.7406 18.2724C9.83469 18.2808 9.07207 17.6527 8.87751 16.8045C8.93331 16.9871 9.1092 17.1106 9.30417 17.1082L12.1575 17.0834C12.3639 17.081 12.5471 16.9388 12.5864 16.7361Z",
    fill: "url(#paint8_linear_87_1131)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0879 22.9516C18.0879 22.9777 18.0879 23.0026 18.0868 23.0265C18.0778 23.2647 18.0221 23.444 17.9948 23.5247C17.2132 25.9125 16.7447 27.1715 16.088 28.1901C15.9745 28.366 15.8554 28.5349 15.7273 28.7007C15.5593 28.9218 15.3755 29.1373 15.1714 29.3596C14.7177 29.8531 14.0315 30.0765 13.8102 30.1536C13.0014 30.4396 12.2868 30.3873 11.8115 30.3918H11.7287C11.2522 30.3873 10.5388 30.4396 9.73 30.1536C9.50882 30.0765 8.82131 29.8531 8.36869 29.3596C7.12088 28.0019 6.6411 26.8732 5.54531 23.5247C5.51925 23.4475 5.46726 23.2806 5.45479 23.0571C5.45133 22.9925 5.44997 22.9279 5.45343 22.8632C5.47726 22.4628 5.63966 22.0704 5.92778 21.712C6.42115 21.0971 7.1835 20.7602 7.97178 20.7568L11.7707 20.7409L15.5004 20.7262C16.3057 20.7228 17.0862 21.0608 17.5977 21.6834C17.845 21.9853 18.0028 22.3109 18.0605 22.6466C18.0685 22.6943 18.0753 22.743 18.0799 22.7906C18.0844 22.8439 18.0879 22.8972 18.0879 22.9516Z",
    fill: "url(#paint9_linear_87_1131)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.77 20.7413L7.97111 20.7573C7.1827 20.7606 6.42048 21.0976 5.92699 21.7123C5.63887 22.0709 5.47672 22.4633 5.45288 22.8638C5.47215 22.453 5.64121 22.0504 5.9418 21.684C6.45222 21.0612 7.23383 20.7233 8.03915 20.7266L11.77 20.7413Z",
    fill: "url(#paint10_linear_87_1131)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5459 26.3382C15.4904 23.3914 15.0915 22.8087 15.6796 22.1076C15.7472 22.0271 16.0922 21.616 16.6594 21.511C17.1114 21.4274 17.5216 21.5723 17.7156 21.6823C18.8949 22.3503 18.5449 25.2464 17.7682 27.0747C17.5989 27.4732 17.1445 28.5425 16.5908 28.517C16.3639 28.5065 16.1967 28.3158 16.0791 28.1783C15.5598 27.5702 15.5542 26.7825 15.5459 26.3382Z",
    fill: "url(#paint11_linear_87_1131)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.088 28.1902C15.9745 28.3661 15.8554 28.535 15.7272 28.7007C15.6863 28.6587 15.65 28.6167 15.6171 28.5782C15.0976 27.9702 15.092 27.183 15.084 26.7382C15.0284 23.7912 14.629 23.2093 15.2179 22.5082C15.261 22.4561 15.4187 22.2689 15.6749 22.1134C15.0942 22.8121 15.4901 23.3999 15.5456 26.3379C15.5537 26.7826 15.5604 27.5697 16.0789 28.1788C16.0822 28.1823 16.0857 28.1857 16.088 28.1902Z",
    fill: "url(#paint12_linear_87_1131)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7505 23.8844C17.7339 23.5677 17.6745 23.3348 17.5556 22.869C17.4003 22.2598 17.2054 21.9627 17.332 21.8451C17.4144 21.7685 17.5768 21.8203 17.6134 21.832C18.1703 22.0096 18.3428 23.0546 18.319 23.7085C18.3042 24.1089 18.2064 24.5566 18.0598 24.5765C18.0365 24.5796 17.9791 24.5765 17.938 24.5402C17.7742 24.3954 17.7632 24.125 17.7505 23.8844Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1333 25.0017C18.1333 25.0655 18.0815 25.1175 18.0177 25.1175C17.9538 25.1175 17.9021 25.0655 17.9021 25.0017C17.9021 24.9379 17.9538 24.8861 18.0177 24.8861C18.0815 24.8861 18.1333 24.9379 18.1333 25.0017Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6019 31.1905C15.5296 31.1905 18.7185 32.4921 18.7185 34.0953C18.7185 35.6984 15.5296 37 11.6019 37C7.6743 37 4.48535 35.6984 4.48535 34.0953C4.48535 32.4921 7.6743 31.1905 11.6019 31.1905Z",
    fill: "url(#paint13_radial_87_1131)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_1131",
    x1: 4.10303,
    y1: 22.3184,
    x2: 16.3159,
    y2: 28.0092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7165E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#72DCB3",
    stopOpacity: 0.995
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E",
    stopOpacity: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_87_1131",
    x1: 10.1562,
    y1: 3.24091,
    x2: 11.916,
    y2: 2.87042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C83DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4530FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4AF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_87_1131",
    x1: 9.54621,
    y1: 1.60089,
    x2: 12.0008,
    y2: 0.497198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C83DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7165E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C3CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_87_1131",
    x1: 9.5692,
    y1: 7.81269,
    x2: 12.9654,
    y2: 4.16954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8C83DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6A1D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_87_1131",
    x1: 5.55541,
    y1: 19.8372,
    x2: 18.0903,
    y2: 7.85798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7165E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5B4CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6A1D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_87_1131",
    x1: 10.1866,
    y1: 15.3975,
    x2: 10.2484,
    y2: 10.5194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#071E2D",
    stopOpacity: 0.995
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2F45",
    stopOpacity: 0.99
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_87_1131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.1143 13.035) scale(2.13054)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3280FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#19407E",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_87_1131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.30988 13.035) scale(2.13054)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3280FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#19407E",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_87_1131",
    x1: 10.3726,
    y1: 17.5126,
    x2: 13.8667,
    y2: 14.2387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#76D29D",
    stopOpacity: 0.995
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E",
    stopOpacity: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_87_1131",
    x1: 8.5206,
    y1: 28.9357,
    x2: 16.8337,
    y2: 17.9493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E5EFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#7D6FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7664FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7E71F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8478F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_87_1131",
    x1: 6.94423,
    y1: 22.7198,
    x2: 12.6868,
    y2: 16.2362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#857AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8076D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#877BE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_87_1131",
    x1: 19.8337,
    y1: 26.5905,
    x2: 13.2884,
    y2: 23.1325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7567EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#6756FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C83DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_87_1131",
    x1: 13.9383,
    y1: 26.2715,
    x2: 18.0755,
    y2: 23.9251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7165E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7165E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#766ADE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_87_1131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6019 34.0953) scale(6.89883 2.81585)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#978EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#DEEBEB",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotImage);
export default __webpack_public_path__ + "static/media/bot-image.1dc7ca5c758a66671acdc8a87ceaebd1.svg";
export { ForwardRef as ReactComponent };